
<div>
  <svg class="loader-spinner fill-current" viewBox="0 0 32 32">
    <circle
      class="loader-spinner__path stroke-current"
      cx="16"
      cy="16"
      r="14"
      fill="none"
      stroke-width="4"
    />
  </svg>
</div>
